import { Dispatch } from "redux";
import { LOGOUT } from "./Types";
import { useDispatch } from "react-redux";
import { useCallback } from "react";
import client from "../../client";

export const useLogout = () => {
  const dispatch = useDispatch();
  return useCallback(
    () => client.resetStore().then(() => dispatchLogout(dispatch)),
    [dispatch],
  );
};
export const dispatchLogout = (dispatch: Dispatch) =>
  dispatch({
    type: LOGOUT,
  });
